import { AnyAction } from "redux";
import { Action } from "typescript-fsa";

import { FormEngineActions } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";
import { Events } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";

export type ButtonAction = Action<FormEngineActions.FormEngineEventActions<Action<Events.EventButtonPayload>>>;
export type RowButtonAction = Action<
	FormEngineActions.FormEngineEventActions<Action<Events.Repeat.CustomRowActionPayload>>
>;

/**
 * Hilfsfunktion, die einen Action Matcher für Button Events in der FormEngine erstellt.
 * @param eventNames liste von Eventnames, die vom Button dispatcht werden.
 */
export function createEventButtonActionMatcher(...eventNames: string[]) {
	return (action: AnyAction): action is ButtonAction =>
		FormEngineActions.event.match(action) &&
		Events.eventButton.match(action.payload.engineEvent) &&
		eventNames.includes(action.payload.engineEvent.payload.name);
}

export function createRowButtonActionMatcher(...eventNames: string[]) {
	return (action: AnyAction): action is RowButtonAction =>
		FormEngineActions.event.match(action) &&
		Events.Repeat.customRowAction.match(action.payload.engineEvent) &&
		eventNames.includes(action.payload.engineEvent.payload.eventName);
}

export function valueChangeActionMatcher() {
	return (action: AnyAction) =>
		FormEngineActions.event.match(action) && Events.valueChange.match(action.payload.engineEvent);
}
